export default {
  setContractors(state, value) {
    state.contractors = value
  },
  setContractor(state, value) {
    state.contractor = value
  },
  setContractorField(state, obj) {
    if (state.contractor) {
      state.contractor[obj.key] = obj.value
    }
  },
  unshiftContractors(state, contractor) {
    state.contractors.unshift(contractor)
  },
  deleteContractor(state, id) {
    for (let i = 0; i < state.contractors.length; i++) {
      if (state.contractors[i].id === id) {
        state.contractors.splice(i, 1)
        break
      }
    }
  },
}
